<template>
  <v-layout row wrap class="pa-0 ma-0">
    <v-flex
      v-for="(ch, index) in checkboxes"
      :key="index"
      class="pa-0"
      md3
      sm6
      xs6
    >
      <v-tooltip color="bg" top :disabled="!hoverable">
        <template v-slot:activator="{ on }">
          <div
            :class="`checkBox ${boxClass[ch.id]} ${disabledClass}`"
            v-on="on"
            v-on:click="onClickHandler(ch)"
            v-on:mouseover="$set(showToolTip, ch.id, true)"
            v-on:mouseleave="$set(showToolTip, ch.id, false)"
          >
            <div :style="{ width: '100%' }" class="font-weight-bold body-2">{{ `${ch.name}` }}</div>
            <div :style="{ width: '100%' }" v-for="(ele, i) in cardParameter"
              :key="`${ele}-${index}-${i}`" class="body-1">
              <span>{{ ele.name }}</span>
              <span :class="ch[ele.value] !== null && ch[ele.value] !== 'No Data' ? 'number--text' : 'error--text'">
                {{
                  ch[ele.value] !== null && ch[ele.value] !== "No Data"
                    ? parseFloat(ch[ele.value]).toFixed(2)
                    : $t("No Data")
                }}
              </span>
            </div>
          </div>
        </template>
        <span class="toooltip-text__color">
          <slot
            name="tooltip"
            :value="ch"
            :showToolTip="showToolTip[ch.id]"
          ></slot>
        </span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cardParameter: {
      type: Array,
      default: function () {
        return [];
      },
    },
    id: String,
    selectAll: {
      type: Boolean,
      default: false,
    },
    clearAll: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    condition: Function,
    hoverable: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },
  data() {
    return {
      showToolTip: {},
      isActive: {},
      checkboxes: [],
    };
  },
  computed: {
    disabledClass() {
      return this.disable ? "disable" : "";
    },
    boxClass() {
      const classObj = {};
      this.checkboxes.forEach((ch, index) => {
        const classString = this.condition(
          ch,
          this.isActive[`${this.id}-${ch.id}`]
        );
        if (classString.includes("default")) {
          let cl = classString.replace(
            "default",
            this.checkboxes[index].status
          );
          classObj[ch.id] = cl;
        } else {
          classObj[ch.id] = classString;
        }
      });
      return classObj;
    },
  },
  mounted() {
    this.checkboxes = _.cloneDeep(this.data);
  },
  methods: {
    onClickHandler(ch) {
      if (!this.disable) {
        const identifier = `${this.id}-${ch.id}`;
        const state = !this.isActive[identifier];

        this.$set(this.isActive, identifier, state);
        this.onClick(ch, state, this.id);
      }
    },
  },
  watch: {
    data() {
      this.checkboxes = _.cloneDeep(this.data);
    },
    selectAll: {
      handler() {
        this.checkboxes.forEach((ch) => {
          if (ch.status !== "not_connected") {
            if (this.selectAll) {
              this.$set(this.isActive, `${this.id}-${ch.id}`, true);
            } else {
              this.$set(this.isActive, `${this.id}-${ch.id}`, false);
            }
          }
        });
      },
      deep: true,
    },
    clearAll() {
      this.isActive = {};
      let eleArr = document.querySelectorAll(`.checkBox`);
      eleArr.forEach((el) => {
        el.classList.forEach((e) => {
          if (typeof e === "string" && e.includes("-select")) {
            el.classList.add(e.replace("-select", ""));
            el.classList.remove(e);
          }
        });
      });
    },
    disable() {
      if (this.disable) {
        this.isActive = {};
        let eleArr = document.querySelectorAll(`.checkBox`);
        eleArr.forEach((el) => {
          el.classList.forEach((e) => {
            if (typeof e === "string" && e.includes("-select")) {
              el.classList.add(e.replace("-select", ""));
              el.classList.remove(e);
            }
          });
        });
      }
    }
  },
};
</script>

<style scoped>
.channel-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.theme--dark .ch-value_selected {
  border-style: solid;
  border-width: thick;
  animation: datas 1s infinite;
}

.theme--light .ch-value_selected {
  border-style: solid;
  border-width: thick;
  animation: datals 1s infinite;
}

.theme--dark .ch-value {
  animation: data 1s infinite;
}

.theme--light .ch-value {
  animation: datal 1s infinite;
}

.ETSD1001-select {
  background-color: #FF5252;
  box-shadow: inset 0 0 0 2px #818fff;
}

.no_issue-select {
  box-shadow: inset 0 0 0 2px #818fff;
}

.known_issue-select {
  background-color: #f5be11;
  box-shadow: inset 0 0 0 2px #818fff;
}

.not_connected-select {
  background-color: #455a64;
  box-shadow: inset 0 0 0 2px #818fff;
}

.communication_error-select {
  background-color: #f69946;
  box-shadow: inset 0 0 0 2px #818fff;
}

.ETSD1001 {
  background-color: #FF5252;
  animation: data 1s infinite;
}

.known_issue {
  background-color: #f5be11;
}

.not_connected {
  background-color: #455a64;
}

.communication_error {
  background-color: #f69946;
}

.no_issue {
  background-color: var(--v-primary-darken1);
}

.checkBox {
  text-align: left;
  margin: 4px;
  padding: 15px;
  border-radius: 4px;
  cursor: pointer;
}

.disable {
  opacity: 0.5;
}

@keyframes datas {
  0%,
  49% {
    background-color: var(--v-primary-darken1);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes data {
  0%,
  49% {
    background-color: var(--v-primary-darken1);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes datals {
  0%,
  49% {
    background-color: var(--v-primary-darken1);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes datal {
  0%,
  49% {
    background-color: var(--v-primary-darken1);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

.theme--light .toooltip-text__color {
  color: #000;
}
</style>
